import { useMemo } from "react";

export const EnvironmentEnum = {
    DEV: "DEV",
    STAGING: "STAGING",
    ITEST: "ITEST",
    APP: "LIVE",
};

export const getEnvironment = () => {
    const currentUrl = window.location.href;
    if (currentUrl.includes("localhost")) {
        return EnvironmentEnum.DEV;
    } else if (currentUrl.includes("staging")) {
        return EnvironmentEnum.STAGING;
    } else if (currentUrl.includes("itest")) {
        return EnvironmentEnum.ITEST;
    } else if (currentUrl.includes("app")) {
        return EnvironmentEnum.APP;
    }
};

export const getEnvironmentColor = () => {
    const environment = getEnvironment();
    if (environment === EnvironmentEnum.STAGING) {
        return "bg-danger";
    } else if (environment === EnvironmentEnum.ITEST) {
        return "bg-warning";
    } else if (environment === EnvironmentEnum.APP) {
        return "bg-success";
    }

    return null;
};

export const getEnvironmentTextAndColor = () => {
    if (getEnvironment() === EnvironmentEnum.DEV) {
        return {};
    }

    return { text: getEnvironment(), colorClass: getEnvironmentColor() };
};

const useEnvironment = () => {
    const environment = useMemo(() => {
        return getEnvironment();
    }, []);

    const color = useMemo(() => {
        return getEnvironmentColor();
    }, []);

    return {
        environment,
        color,
    };
};

export default useEnvironment;
